import GodownItems from '../components/GodownItems';

const Items = () => {
  return <GodownItems type="NON-JW" title="Godown Items" />;
};

export default Items;
